import router from '@/router';
import store from '@/store';
import Vue from 'vue';
import VueTheMask, { mask } from 'vue-the-mask';
import vuetify from '@/plugins/vuetify';
import VueGtm from 'vue-gtm';
import '@/core';
import '@/services/filters';
import '@/services/directives';
import InfiniteLoading from 'vue-infinite-loading';
import * as Sentry from '@sentry/browser';
import { userIsRequired } from '@/router/config';

Vue.use(InfiniteLoading as any, {
  slots: {
    noResults: '',
    noMore: '',
  },
});

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GOOGLE_TAG_MANAGER,
  enabled: process.env.VUE_APP_ONLY_PRODUCTION,
  debug: !process.env.VUE_APP_ONLY_PRODUCTION,
  loadScript: true,
});

const App = () => import('@/app');

Vue.use(VueTheMask);

Vue.config.productionTip = process.env.NODE_ENV === 'production';

const language = localStorage.getItem('language') || 'uk';

const createApp = () => {
  new Vue({
    directives: {
      mask,
    },
    router,
    store,
    vuetify,
    render: (h) => h(App),
    mounted: () => document.dispatchEvent(new Event('x-app-rendered')),
  }).$mount('#app');
};

const loadApp = () => {
  return new Promise(async (resolve, reject) => {
    try {
      await store.dispatch('getNavigation');
      createApp();
      resolve(true);
    } catch (error) {
      Sentry.captureException(error);
      reject(error);
    }
  });
};

void (async () => {
  const logged = store.getters['user/logged'];
  const lang: string | null = await Promise.resolve(localStorage.getItem('language'));
  if (typeof lang === 'string' && !!lang.length) {
    await store.dispatch('setUserLanguage', lang);
  }
  if (!logged && !!userIsRequired.filter((item) => location.pathname.includes(item)).length) {
    try {
      await store.dispatch('user/loginByAccessToken');
      await loadApp();
    } catch (err) {
      Sentry.captureException(err);
    }
  } else {
    store.dispatch('user/loginByAccessToken');
    loadApp();
  }
})();
